// QuoteRequestButton.js
import React, { useState, forwardRef, useImperativeHandle } from "react"
import { Button } from "react-bootstrap"
import { useDispatch } from "react-redux"
import { toast } from "react-toastify"
import QuoteRequestModal from "./QuoteRequestModal"
import { isLogin } from "../../../helpers/login"
import { setIsLoginModalOpen } from "../../../store/reducers/global-reducer"

const QuoteRequestButton = forwardRef((props, ref) => {
  const {
    productId = null,
    serviceId = null,
    sellerId,
    itemName,
    itemImage,
    itemPrice,
    className = "btn btn_yellow_2",
    buttonText = "Request Quote",
    showButton = false,
  } = props

  const [showModal, setShowModal] = useState(false)
  const dispatch = useDispatch()
  const currentUser = isLogin()

  const handleQuoteRequest = () => {
    if (!currentUser) {
      toast.error("Please login to proceed.")
      sessionStorage.setItem("redirectTo", window.location.pathname)
      dispatch(setIsLoginModalOpen({ isLoginModalOpen: true }))
      return
    }
    setShowModal(true)
  }

  // Expose method to parent
  useImperativeHandle(ref, () => ({
    open: () => handleQuoteRequest(),
  }))

  return (
    <>
      {showButton && (
        <Button className={className} onClick={handleQuoteRequest}>
          {buttonText}
        </Button>
      )}

      <QuoteRequestModal
        show={showModal}
        onHide={() => setShowModal(false)}
        productId={productId}
        serviceId={serviceId}
        sellerId={sellerId}
        itemName={itemName}
        itemImage={itemImage}
        itemPrice={itemPrice}
        isEditing={false}
      />
    </>
  )
})

export default QuoteRequestButton
